/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-10 15:26:55
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Page, Layout, Card } from '@shopify/polaris';
import { URL } from 'src/constants/links';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import Carousel from 'react-multi-carousel';
import PlansReview from 'src/components/views/subscription-v4/plans-review';
import PlansQA from 'src/components/views/subscription-v4/plans-qa';

import MainMenu from 'src/components/containers/main-menu';
import DidYouKnow from 'src/components/views/subscription-v4/did-you-know';
import DidYouKnowExceed from 'src/components/views/subscription-v4/did-you-know.exceed';
import RegularExpiredModal from 'src/components/views/subscription-v4/modal/regular-expired-modal';
import SpecialDiscountCodeExpiredModal from 'src/components/views/subscription-v4/modal/special-discount-code-expired-modal';
import PasswordProtectedOfferExpiredModal from 'src/components/views/subscription-v4/modal/password-protected-offer-expired-modal';
import AddonCard from 'src/components/views/subscription-v4/addon/addon-card';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
import StatusModal from 'src/components/views/subscription-v4/modal/status-modal';
import ExceededPlanModal from 'src/components/views/subscription-v4/modal/exceeded-plan-modal';

import readTimeIcon from 'src/assets/images/subscription-v3/read-time_minor.png';
import {
  allowToSubscribeBFCMCode,
  isSpecialDiscount2021Expired,
  getSubscribePlanInfo,
  buildListAddonV4,
  getCorrectPlanV4,
  checkUsingVariantForFree
} from 'src/helpers/subscription-v3-helper';
import { PACKAGES_V4 } from 'src/constants/subscription';
import * as subscriptionV3Actions from 'src/stores/actions/subscription-v3-actions';
import * as checklistActions from 'actions/dashboard/checklist-actions';

import history from 'src/routes/history';
import { routes } from 'src/routes';
import SpecialDiscountBlockNotification from 'src/components/views/campaigns/bfcm2022/special-discount-block-notification';

import SpecialDiscountExpiredModal from 'src/components/containers/common/notificationSubscription/special-discount-notification';
import {
  enableNewPricingPageExceededUser,
  getSubscriptionStatus
} from 'src/helpers/subscription-v3-helper';
import EnterpriseBlock from 'src/components/views/subscription-v4/enterprise-block';
import ReviewBlock from 'src/components/views/subscription-v4/review-block';
import EnterpriseLModal from 'src/components/views/subscription-v4/modal/enterprise-modal';

type Props = {
  selectedPlan: string,
  currentTotalProducts: number,
  subscribing: boolean,
  subscription: Object
};

type ComposedProps = Props & WithI18nProps;

type State = {
  status: string,
  productsPlan: string,
  dayLeft: number,
  regularExpiredAt: String,
  correctPlan: Object,
  activeExpiredModal: boolean,
  activeRegularExpiredModal: boolean,
  activeEnterpriseModal: Boolean,
  activeExceededModal: boolean,
  packageSelected: Object,
  planNumberRequest: Object
};

function planWrapper(WrappedComponent: Object) {
  class HOCPlan extends Component<ComposedProps, State> {
    state = {
      status: '',
      productsPlan: '1000',
      dayLeft: 0,
      addonList: [],
      regularExpiredAt: '',

      // Expired modal
      activeExpiredModal: false,

      // Expired modal for special discount code
      activeSpecialDiscountCodeExpiredModal: false,

      // Exceeded modal
      activeExceededModal: false,

      // Password protected offer expired modal
      activePasswordProtectedOfferExpiredModal: false,

      // Regular plan of shopify plus expired modal
      activeRegularExpiredModal: false,

      // Talk to sale modal
      activeEnterpriseModal: false,

      openModalSubscribeSuccess: false,
      packageSelected: null,
      planNumberRequest: null
    };

    async componentDidMount() {
      const {
        allAddon = {},
        subscription,
        tenantApp = {},
        getAddons,
        invoice,
        packagePlans,
        getPackagePlans,
        getDetailInvoice,
        trackEvent
      } = this.props;

      const { planNumber } = this.props.match?.params || {};
      this.setState({ planNumberRequest: planNumber });

      // Open modal success after subscribe and remove query statusSubscribe
      const search: string = _.get(history.location, 'search', '');
      if (_.includes(search, 'statusSubscribe=success')) {
        this.setState({ openModalSubscribeSuccess: true });

        const removeSearch = search.replace('statusSubscribe=success', '');
        history.replace({ ...history.location, search: removeSearch });
        trackEvent('csatFeedback', 'makePayment', 'csatFeedback_makePayment');
      }

      // Get detail invoice

      if (_.isEmpty(invoice) || !invoice) {
        await getDetailInvoice();
      }

      // Get all addons
      await getAddons();

      // Get all package plan
      if (!_.get(packagePlans, 'basic', []).length) {
        await getPackagePlans();
      }

      // Reset discount when push to discount page
      this.props.clearDiscountCode();

      const specialDiscountExpiredAt = _.get(tenantApp, 'specialDiscountExpiredAt', 0);
      const passwordProtectedOfferExpired = _.get(
        tenantApp,
        'passwordProtectedOffer.isExpired',
        false
      );

      // Get subscription status
      const { status, productsPlan, dayLeft, regularExpiredAt = '' } = subscription;

      // Show special discount expired modal from day 8 after expired time
      const isBFCM2021Expired = isSpecialDiscount2021Expired(status, specialDiscountExpiredAt, 7);

      // Build list addon explore
      if (allAddon && !_.isEmpty(allAddon)) {
        const useFreeVariant = checkUsingVariantForFree(tenantApp);
        const addonBuilt = buildListAddonV4(allAddon, status, useFreeVariant);

        this.setState({
          addonList: addonBuilt.filter(e => e.status !== 'added')
        });
      }

      this.setState({
        status,
        productsPlan,
        dayLeft,
        regularExpiredAt,
        activeSpecialDiscountCodeExpiredModal: isBFCM2021Expired, // Show expired notice
        // activeExpiredModal:
        //   status === 'expired' && window.location.pathname !== '/plan-discount' ? true : false, // Show expired notice
        activeExceededModal: status === 'exceeded' ? true : false,
        activeRegularExpiredModal: status === 'regularExpired' ? true : false,
        activePasswordProtectedOfferExpiredModal: passwordProtectedOfferExpired
      });
    }

    componentWillReceiveProps(nextProps) {
      const { loading: prevLoading = false } = this.props;
      const {
        loading = false,
        allAddon = {},
        getAddonSuccess = false,
        subscription,
        tenantApp
      } = nextProps;

      const { status } = subscription;

      if (prevLoading === true && loading === false && getAddonSuccess === true) {
        const useFreeVariant = checkUsingVariantForFree(tenantApp);
        const addonBuilt = buildListAddonV4(allAddon, status, useFreeVariant);

        this.setState({ addonList: addonBuilt.filter(e => e.status !== 'added') });
      }
    }
    // Handle select package
    handleChangeNumProducts = e => {
      this.setState({ packageSelected: e });
    };

    // goToComparison = packagePlans => {
    //   const { packageSelected } = this.state;
    //   const { currentTotalProducts } = this.props;
    //   let productCount = packageSelected;
    //   if (!packageSelected || packageSelected === LARGE_PRODUCT_LABEL || packageSelected === 'undefined') {
    //     const productNumbers = _.get(packagePlans, 'basic', []).map(i => i.products);
    //     const numberProductSuggest =
    //       productNumbers.find(products => products > currentTotalProducts) ||
    //       _.reverse([...productNumbers])[0];
    //     productCount = numberProductSuggest;
    //   }

    //   history.push(routes.subscription.comparison(productCount));
    // };

    goToComparison = () => {
      const { packageSelected } = this.state;
      history.push(routes.subscription.comparison(packageSelected || 1000));
    };

    render() {
      const {
        status,
        addonList,
        activeExceededModal,
        activeRegularExpiredModal,
        activeSpecialDiscountCodeExpiredModal,
        activePasswordProtectedOfferExpiredModal,
        activeEnterpriseModal,
        openModalSubscribeSuccess
      } = this.state;
      const { tenantApp, i18n, correctPlan, invoice = {}, selectedPlan } = this.props;

      const subscriptionStat = getSubscriptionStatus(tenantApp);
      const subscriptionStatus = _.get(subscriptionStat, 'status', '');

      const enableForExceededUser = enableNewPricingPageExceededUser(tenantApp);

      // Check applying BFCM Discount code
      const suggestBFCMCode = allowToSubscribeBFCMCode(tenantApp);

      const planInfo = getSubscribePlanInfo(correctPlan, invoice);

      const planPackageName = _.get(planInfo, 'name', 'basic')
        ? _.get(planInfo, 'name', 'basic')
        : 'basic';
      const packageInfo = PACKAGES_V4.find(e => _.includes(planPackageName, e.name));

      // Render content status for case subscribe success
      const infoStatus = {
        hasContent: true,
        status: 'success',
        title: i18n.translate('AdminHTML.SubscriptionV4.SetupComplete.title'),
        content: i18n.translate('AdminHTML.SubscriptionV4.SetupComplete.content'),
        subContent: '',
        actionLabel: i18n.translate('AdminHTML.SubscriptionV4.ActionButton.backHomePage'),
        secondaryActionLabel: i18n.translate('AdminHTML.Common.Action.close'),
        handleAction: this.handleBackHomepage
      };
      return (
        <div className="BC-Page BC-Page__SubscriptionV3 V4">
          <MainMenu menuId="menu-account-subscription" />
          <Page title={i18n.translate('AdminHTML.SubscriptionV4.subscription')}>
            <div className="sub-info-page">
              <img src={readTimeIcon} alt="primary-icon" />
              <a href={URL['PricingPlanBilling']} target="blank">
                {i18n.translate('AdminHTML.Common.Action.learnMore')}
              </a>
            </div>
            <Layout>
              <Layout.Section>
                <div className="BC-Container__Notifications">
                  <SpecialDiscountBlockNotification />
                  {/* Information box */}
                  {enableForExceededUser ? <DidYouKnowExceed /> : <DidYouKnow />}
                  {/* Sticky notification for special discount code */}
                  <SpecialDiscountExpiredModal />
                  {/* Sticky notification for exceeded plan */}
                  <ExceededPlanNotification />
                </div>
              </Layout.Section>

              <Layout.Section>
                {/* Wrapped component: Plan, Plan discount, Plan large*/}
                <WrappedComponent
                  {...this.props}
                  {...this.state}
                  planInfo={planInfo}
                  packageInfo={packageInfo}
                  handleChangeShowInformation={this.handleChangeShowInformation}
                />
              </Layout.Section>

              {subscriptionStatus === 'trial' && (
                <Layout.Section>
                  <EnterpriseBlock onTalkToSale={() => this.toggleModal('activeEnterpriseModal')} />
                </Layout.Section>
              )}

              {addonList && addonList.length > 0 && !selectedPlan.includes('freemium') && (
                <Layout.Section>
                  <div className="addon-card-preview">
                    <Card
                      title={
                        <div className="cardTitle">
                          <span className="Polaris-Heading">
                            {i18n.translate('AdminHTML.SubscriptionV4.planAddonHeader')}
                          </span>
                        </div>
                      }
                      sectioned>
                      <Carousel
                        additionalTransfrom={0}
                        arrows
                        autoPlaySpeed={3000}
                        centerMode={false}
                        className=""
                        containerClass="BC_AddonList-Sliders"
                        draggable
                        focusOnSelect={false}
                        infinite
                        itemClass=""
                        keyBoardControl
                        minimumTouchDrag={80}
                        pauseOnHover
                        renderArrowsWhenDisabled={false}
                        renderButtonGroupOutside={false}
                        renderDotsOutside={true}
                        responsive={{
                          desktop: {
                            breakpoint: {
                              max: 3000,
                              min: 1024
                            },
                            items: 3.3,
                            partialVisibilityGutter: 40
                          },
                          mobile: {
                            breakpoint: {
                              max: 464,
                              min: 0
                            },
                            items: 1,
                            partialVisibilityGutter: 30
                          },
                          tablet: {
                            breakpoint: {
                              max: 1024,
                              min: 464
                            },
                            items: 2,
                            partialVisibilityGutter: 30
                          }
                        }}
                        rewind={false}
                        rewindWithAnimation={false}
                        rtl={false}
                        shouldResetAutoplay
                        sliderClass=""
                        slidesToSlide={
                          window.innerWidth >= 1024 ? 3 : window.innerWidth >= 464 ? 2 : 1
                        }
                        swipeable>
                        {addonList.map((e, index) => (
                          <AddonCard
                            key={`item+${index}`}
                            addon={e}
                            handleAfterSubscribeAddon={this.handleAfterSubscribeAddon}
                          />
                        ))}
                      </Carousel>
                    </Card>
                  </div>
                </Layout.Section>
              )}

              <Layout.Section>
                <ReviewBlock />
              </Layout.Section>

              <div>
                <PlansReview />
                <PlansQA />
              </div>
            </Layout>

            {/* Not show exceeded plan modal in BFCM campaign for page /plan */}
            {!suggestBFCMCode && (
              <ExceededPlanModal
                active={activeExceededModal}
                handleSubscribe={this.handleSubscribe}
              />
            )}

            {/* Show expired modal for special discount code */}
            {status === 'oldSpecialDiscountExpired' && (
              <SpecialDiscountCodeExpiredModal
                active={activeSpecialDiscountCodeExpiredModal}
                handleSubscribe={this.handleSubscribeAfterSpecialDiscount}
              />
            )}

            {/* Show expired modal for password protected offer */}
            <PasswordProtectedOfferExpiredModal
              active={activePasswordProtectedOfferExpiredModal}
              handleChange={this.handleChangePasswordProtectedModal}
            />

            {status === 'regularExpired' && (
              <RegularExpiredModal
                active={activeRegularExpiredModal}
                handleChange={this.handleChangeRegularExpiredModal}
                handleAction={this.handleViewPackage}
              />
            )}
            <StatusModal
              active={openModalSubscribeSuccess}
              infoStatus={infoStatus}
              secondaryAction={() => this.toggleModal('openModalSubscribeSuccess')}
              handleCancel={() => this.toggleModal('openModalSubscribeSuccess')}
            />

            {/* Modal: Request large plan */}
            <EnterpriseLModal
              active={activeEnterpriseModal}
              products={50000}
              handleCancel={() => this.toggleModal('activeEnterpriseModal')}
            />
          </Page>
        </div>
      );
    }

    // Toggle modal
    toggleModal = fieldName => {
      const value = this.state[fieldName];
      this.setState({ [fieldName]: !value });
    };
    // Handle show/hide expired modal
    handleChangeModal = () => {
      this.setState(({ activeExpiredModal }) => ({
        activeExpiredModal: !activeExpiredModal
      }));
    };

    handleChangeRegularExpiredModal = () => {
      this.setState(({ activeRegularExpiredModal }) => ({
        activeRegularExpiredModal: !activeRegularExpiredModal
      }));
    };
    handleChangePasswordProtectedModal = () => {
      this.setState(({ activePasswordProtectedOfferExpiredModal }) => ({
        activePasswordProtectedOfferExpiredModal: !activePasswordProtectedOfferExpiredModal
      }));
    };

    // Handle subscribe exceeded modal
    handleSubscribe = () => {
      this.setState({ activeExceededModal: false });
      // history.push(routes.subscription.plan());
    };

    handleAfterSubscribeAddon = () => {
      this.props.getDetailInvoice();
      this.props.getAddons();
    };

    // Handle subscribe after active modal special discount bcfm 2021
    handleSubscribeAfterSpecialDiscount = () => {
      this.setState({ activeSpecialDiscountCodeExpiredModal: false });
    };

    handleBackHomepage = () => {
      this.toggleModal('openModalSubscribeSuccess');
      history.push('/');
    };
    // Open addon page
    handleViewPackage = () => {
      history.push(routes.subscription.package());
    };
  }

  const mapDispatchToProps = (dispatch, ownProps) => ({
    clearDiscountCode: () => dispatch(subscriptionV3Actions.clearDiscountCode()),
    getAddons: () => dispatch(subscriptionV3Actions.getAddons(ownProps.i18n)),
    unsubscribeAddon: (addonId, addonName) =>
      dispatch(subscriptionV3Actions.unsubscribeAddon(addonId, addonName, ownProps.i18n)),
    getPackagePlans: () => dispatch(subscriptionV3Actions.getPackagePlans(ownProps.i18n)),
    getDetailInvoice: () => dispatch(subscriptionV3Actions.getDetailInvoice(ownProps.i18n)),
    trackEvent: (eventSource, eventName, label) =>
      dispatch(checklistActions.trackEvent(eventSource, eventName, label))
  });

  const mapStateToProps = (state, props) => {
    const tenantApp = _.get(state.oauth, 'tenantApp', {});
    const tenantId = _.get(state.oauth, 'tenantApp.tenantId', {});
    const externalInfo = _.get(tenantApp, 'externalInfo', {});
    const packagePlans = _.get(state.subscriptionV3, 'packagePlans', {});
    const selectedPlan = _.get(state.oauth.tenantApp, 'selectedPlan', '');
    const chargeInfo = _.get(state.subscriptionV3, 'invoice.chargeInfo', {});
    // Get correct plan
    const invoice = _.get(state.subscriptionV3, 'invoice', {});
    const currentTotalProducts = _.get(tenantApp, 'appParams.currentTotalProducts');
    const correctPlan = getCorrectPlanV4(
      chargeInfo,
      packagePlans,
      currentTotalProducts,
      selectedPlan
    );

    return {
      tenantApp,
      correctPlan,
      invoice,
      selectedPlan: _.get(state.oauth.tenantApp, 'selectedPlan'),
      gettingInvoice: _.get(state.subscriptionV3, 'gettingInvoice', false),
      gettingPackage: _.get(state.subscriptionV3, 'gettingPackage', false),
      packagePlans,

      currentTotalProducts,
      subscribing: _.get(state.subscriptionV3, 'subscribing', false),
      subscribeSuccess: _.get(state.subscriptionV3, 'subscribeSuccess', false),
      subscription: _.get(state.oauth, 'subscription', {}),
      allAddon: _.get(state.subscriptionV3, 'addons', []),
      loading: _.get(state.subscriptionV3, 'loading', false),
      getAddonSuccess: _.get(state.subscriptionV3, 'getAddonSuccess', false),
      unsubscribing: _.get(state.subscriptionV3, 'unsubscribing', false),
      addonSubscribeSuccess: _.get(state.subscriptionV3, 'addonSubscribeSuccess', false),
      addonSubscribing: _.get(state.subscriptionV3, 'addonSubscribing', false),
      tenantId,
      planName: _.get(externalInfo, 'plan_name', ''),
      confirmationUrl: _.get(state.subscriptionV3, 'confirmationUrl', '')
    };
  };

  return withI18n()(connect(mapStateToProps, mapDispatchToProps)(HOCPlan));
}

export default planWrapper;
